import React from 'react';
import './Chapters.scss';
import PullQuote from '../PullQuote/PullQuote';

function Chapter6() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__title">Mobility</p>
        <p className="chapter__paragraph">
          Another key component of the fully connected SmartTown is mobility. Ilhan describes
          getting groceries, sending out for deliveries, booking a car service to go somewhere
          within the facility—or even to the airport—all available with streamlined access through
          your smartphone.
        </p>
        <p className="chapter__paragraph">
          Better still, EV charging stations won’t simply check a box in the corner of the parking
          garages, Intel’s partner company Boutique Hotel Professionals (BHP) is making them a
          showcase attraction to bring travelers in from I-25 and drive new business for the site’s
          retail, restaurant, and hotel spaces. When these EV drivers stop for a charge, they’ll
          have the opportunity to enjoy amenities across the property.
        </p>
        <p className="chapter__paragraph">
          Another positive impact technology can have on the mobility sector is in regard to
          parking. It can be frustrating to visit a town center only to end up circling endlessly
          searching for parking. This has a negative impact on the user experience as well as the
          environment. Miller’s Landing plans to attack this problem with technology, specifically a
          mobile app that will alert users to available parking spots and the ability to reserve a
          spot in advance.
        </p>
      </section>

      <section className="chapter">
        <p className="chapter__title">The Hotel</p>
        <p className="chapter__paragraph">
          Part of the first construction phase is a more-than-300-room full-service hotel and event
          center. Three ballrooms and a ground-level restaurant offer ample opportunities for
          technology to elevate the guest experience.
        </p>
        <p className="chapter__paragraph">
          Jenifer Neptune with BHP describes their strategy for the technology layer of the Miller’s
          Landing hotel as forward-thinking, intuitive, and secure. All technologies within these
          parameters are on the table: intelligent lighting to control the white balance and
          splashes of color for ambiance. These settings can be as subtle as shifts in color
          temperature based on the time of day, or as front-and-center as feature lighting for
          corporate events.
        </p>
        <p className="chapter__paragraph">
          The restaurant and retail amenities of the hotel are experiences that will be extended
          throughout the property. “We believe creating community and walkability requires an active
          ground floor experience,” Wilkinson says, “especially along the main thoroughfare through
          Miller’s Landing, Saddlemaker Trail.”
        </p>
      </section>
      <section>
        <PullQuote
          quote={
            'We believe creating community and walkability requires an active ground floor experience, especially along the main thoroughfare through Miller’s Landing, Saddlemaker Trail.'
          }
          author={'Ken Wilkinson,'}
          source={'Layer 10'}
        />
      </section>
    </>
  );
}

export default Chapter6;
